import { ia } from 'lib/helpers/utility';

export const medicationFooterText = (data) => {
  return ia(data)
    ? data.length === 1
      ? `Show medication (${data.length})`
      : `Show all medications (${data.length})`
    : '';
};
